import {GlobalVariables} from "../GlobalVariables";

export default class DevHelpers {
	static init() {
		GlobalVariables.devMode = Boolean(localStorage.getItem('devMode'));

		if (GlobalVariables.devMode) {
			document.body.classList.add('debug-mode');
			document.querySelector("body").insertAdjacentHTML("beforeend", `<div class="debug-viewport-info">debug on</div>`);
			this.debugDiv = document.querySelector(".debug-viewport-info");
			this.viewportSizeHelper();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	static viewportSizeHelper() {
		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;
		this.debugDiv.innerHTML = `${viewportWidth}px &times; ${viewportHeight}px`;
	}

	static resize() {
		this.viewportSizeHelper();
	}

	static clamp(value, min, max) {
		return Math.min(Math.max(value, min), max);
	}

	static convertRemToPixels(rem) {
		return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}
}

